import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processedRef = useRef(false);
  
  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    
    const processAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      
      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }
      
      try {
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/callback`,
          null,
          {
            params: { session_id: sessionId },
            withCredentials: true
          }
        );
        
        const user = response.data;
        login(user);
        
        // If user hasn't set up profile, go to setup
        const pendingCode = localStorage.getItem('pending_partner_code');
        if (!user.picture || !user.relationship_start_date) {
          navigate('/profile-setup', { replace: true });
        } else if (pendingCode && !user.has_partner && !user.partner_id) {
          navigate(`/connection?code=${pendingCode}`, { replace: true });
        } else {
          navigate('/reminders', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };
    
    processAuth();
  }, [navigate, login]);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-neutral-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
